import React from 'react';
//import { store } from './store.js';
import { store } from './Editor';


async function handleTemplateAction() {

	const hasProductName = store.custom?.productName !== undefined;

if (hasProductName) {
  // Premier popup de choix
// eslint-disable-next-line no-restricted-globals
  const saveTemplateConf = confirm(
    "Voulez-vous enregistrer le template actuel ?\nCliquez sur OK pour enregistrer, Annuler pour créer un nouveau."
  );

  if (saveTemplateConf) {
    // Enregistrement du template existant en JSON


// Envoi du JSON à l'API pour mise à jour
      try {
        const response = await fetch("/api/update-template.php", {
          method: "POST",
          body: JSON.stringify({
            json_name: store.custom?.productName,
            json_content: store.toJSON()
          }),
          headers: {
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
          alert("Template mis à jour avec succès !");
        } else {
          alert("Erreur lors de la mise à jour");
        }
      } catch (error) {
        console.error("Erreur:", error);
        alert("Échec de la mise à jour");
      }
      
} else {
      const templateName = prompt("Entrez le nom du nouveau template :");
      if (templateName) {
        await createNewTemplate(templateName);
      }
    }

  } else {
    const templateName = prompt("Entrez le nom du nouveau template :");
    if (templateName) {
      await createNewTemplate(templateName);
    }
  }
}      
      
  async function createNewTemplate(templateName) {
    // Création d'un nouveau template

    if (templateName) {
//      alert(`Nouveau template "${templateName}" créé !`);

	//On enregistre le nom dans le template
	store.set({
  		custom: {
    	productName: templateName
		  }
	})

      try {
        // Génération de la preview avec Polotno
        const dataUrl = await store.toDataURL({
          pixelRatio: 0.1, // Qualité de l'image
          format: 'image/png'
        });

        // Envoi au serveur (exemple avec Fetch API)
        const response = await fetch("/api/save-preview.php", {
          method: "POST",
          body: JSON.stringify({
            name: templateName,
            theimage: dataUrl
          }),
          headers: {
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
		saveTemplate(templateName, store.toJSON());
        } else {
          alert("Erreur lors de l'enregistrement");
        }
      } catch (error) {
        console.error("Erreur:", error);
        alert("Échec de l'enregistrement");
      }
    }
  }


// Utilisation avec un bouton dans votre HTML
//document.getElementById("save-btn").addEventListener("click", handleTemplateAction);
document.addEventListener("DOMContentLoaded", () => {
  const saveBtn = document.getElementById("save-btn");
  if (saveBtn) {
    saveBtn.addEventListener("click", handleTemplateAction);
  } else {
    console.error("L'élément avec l'ID 'save-btn' n'existe pas.");
  }
});


async function saveTemplate(templateName, templateData) {
    try {
        const response = await fetch('api/save-template.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                json_name: templateName,
                json_content: templateData
            })
        });

        const result = await response.json();
        if (!result.success) throw new Error(result.error);

        console.log('Succès :', result.message);
        alert("Template enregistré");
        return result;

    } catch (error) {
        console.error('Erreur :', error);
        return { success: false };
    }
}

